module.exports = __webpack_public_path__ + "static/media/funnel.1e4bca49.png";